import { createFileRoute } from '@tanstack/react-router'

import { AccountPageSkeleton } from '#/modules/account/front-office/account-page/account-page-skeleton.tsx'
import { AccountPage } from '#/modules/account/front-office/account-page/account-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/account-v2')({
  beforeLoad: ({ context }) => requirePermissions(context, ['user.read']),
  loader: ({ context }) => {
    const { queryClient, trpc } = context
    // The _shell loader already warms loadMyInformation + listMyContracts; the address is the only
    // account-specific block, ensured here so the screen never re-suspends after the pending state.
    return Promise.all([
      queryClient.ensureQueryData(trpc.users.loadMyInformation.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS)),
      queryClient.ensureQueryData(
        trpc.contracts.getLastCustomerAddress.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
      ),
      queryClient.ensureQueryData(
        trpc.contracts.listMyContracts.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
      ),
    ])
  },
  pendingComponent: AccountPageSkeleton,
  pendingMs: 150,
  component: AccountPage,
})
